// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"PromocodesList_contentComponent__2E2Fp","extraContent":"PromocodesList_extraContent__lQffG","createButton":"PromocodesList_createButton__1LW7q"};